<template>
  <!-- 头部整体盒子 -->
  <div id="header"
       class="container-fuild">
    <!-- 头部顶部 -->
    <div class="header-top container-fuild">
      <div class="header-top-bg">
        <div class="container">
          <div class="en">China International Medical Foundation</div>
          <!-- 搜索 -->
          <div class="header-search hidden-sm hidden-xs">
            <i class="iconfont icon-sousuo"
               @click="handleInput" />
            <input class="search-input"
                   placeholder="搜索"
                   v-model="seachKeyword"
                   @keydown.enter="handleInput" />
          </div>
        </div>
      </div>
    </div>
    <div class="header-nav-background">
      <div class="header-nav-background-img">
        <div>
          <!-- 导航logo -->
          <div class="header-nav-logo">
            <!-- <svg-icon icon-class="logo" /> -->
            <img src="@/assets/img/logo.png">
          </div>
        </div>
        <!-- 电脑导航 -->
        <div class="header-nav-container">
          <div class="header-nav hidden-xs  hidden-sm container">
            <!-- 导航logo -->
            <!-- <div class="header-nav-logo">
              <img src="@/assets/img/logo.png">
            </div> -->
            <!-- 导航内容 -->
            <ul class="header-nav-wrapper">
              <li v-for="(item,index) in menuData"
                  :key="index"
                  :class="item.id==navIndex?'active':''"
                  @click="navClick(index, item)">
                <a class="color_primary"
                   v-if="item.path == '/pro_inlet'"
                   @click="handlePro">
                  {{item.name}}
                  <!-- <span v-if="item.children.length>0"
                        class="glyphicon glyphicon-menu-down"></span>
                  <i class="underline"></i> -->
                </a>
                <a class="color_primary"
                   v-else
                   @click="() => navClick(index, item)">
                  {{item.name}}
                  <!-- <span v-if="item.children.length>0"
                        class="glyphicon glyphicon-menu-down"></span> -->
                  <!-- <i class="underline"></i> -->
                </a>
                <dl v-if="item.children.length>0">
                  <dt v-for="(i,n) in item.children"
                      :key="n"
                      @click="(e) => handleClick(i, e)">
                    <a @click="(e) => handleS(i, e)">{{i.name}}</a>
                  </dt>
                </dl>
              </li>
            </ul>

          </div>
        </div>
      </div>
    </div>
    <!-- 手机导航 -->
    <div class="header-nav-m container-fuild visible-xs visible-sm">
      <!-- <div class="header-nav-m-logo">
        <img class="center-block"
             src="@/assets/img/logo_black.png"
             alt="logo">
      </div> -->
      <!-- 导航栏 -->
      <!-- 导航内容 -->
      <li class="header-search">
        <i class="iconfont icon-sousuo"
           @click="handleSearch" />
      </li>
      <div class="header-nav-m-menu text-center"
           data-toggle="collapse"
           @click="menuClick"
           data-target="#menu">
        <!-- {{menuName}} -->
        <span class="header-nav-m-menu-wrapper">
          <span :class="menuClass"></span>
        </span>
        <ul id="menu"
            class="header-nav-m-wrapper collapse">
          <li v-for="(item,index) in menuData.filter(item => {return item.path != '/pro_inlet'})"
              :key="index"
              :class="item.id==navIndex?'active':''"
              @click="navClick(index, item)"
              data-toggle="collapse"
              data-target="#menu">
            <router-link :to="item.path">
              {{item.name}}
              <i class="underline"></i>
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
  import { getMenuList } from "@/api/api"
  import { mapGetters } from "vuex"

  export default {
    name: "Header",
    data() {
      return {
        navIndex: 1,
        menuName: "首页",
        menuClass: "iconfont icon-caidan",
        loginUrl: "",
        seachKeyword: "",
        visibility: "hidden"
      }
    },
    computed: {
      ...mapGetters(["menuData"])
    },
    watch: {
      $route(to, from) {
        let path = "/" + to.path.split("/")[1]
        if (path == "/" || path == "/home") {
          this.navIndex = 1
          sessionStorage.setItem("navIndex", "1")
        } else {
          for (let i = 0; i < this.menuData.length; i++) {
            let item = this.menuData[i]
            if (item.path == path) {
              this.navIndex = item.id
              sessionStorage.setItem("navIndex", item.id)
              this.menuName = item.name
              break
            }
          }
        }
        this.seachKeyword = this.$route.query.keyword || ""
      }
    },
    created() {
      this.navIndex =
        this.$route.path == "/" || this.$route.path == "/home"
          ? 1
          : sessionStorage.getItem("navIndex")
    },
    mounted() {
      this.loginUrl = window.loginUrl
      this.seachKeyword = this.$route.query.keyword || ""
    },
    methods: {
      navClick(index, item) {
        sessionStorage.setItem("keyword", "")
        if (item.path == "/pro_inlet") {
        } else {
          this.navIndex = item.id
          sessionStorage.setItem("navIndex", item.id)
          this.menuName = item.name
          if (item.children && item.children.length > 0) {
            // console.log(item.children)
            sessionStorage.setItem("childId", item.children[0].id)
          }
          this.$router.push(
            item.path,
            () => {},
            () => {}
          ) //跳转
        }
      },
      menuClick() {
        if (this.menuClass == "iconfont icon-caidan") {
          this.menuClass = "iconfont icon-guanbi"
        } else {
          this.menuClass = "iconfont icon-caidan"
        }
      },
      handleMenu() {
        getMenuList().then((res) => {
          // console.log(res)
        })
      },
      handleS(item, e) {
        if (item.id == 901 || item.id == 902 || item.id == 903) {
          window.open(item.path, "_blank")
        } else {
          e.stopPropagation()
          sessionStorage.setItem("childId", item.id)
          sessionStorage.setItem("keyword", "")
          setTimeout(() => {
            this.$router.push(
              item.path,
              () => {},
              () => {}
            )
          }, 200)
        }
      },
      handleClick(item, e) {
        if (item.id == 901 || item.id == 902 || item.id == 903) {
          window.open(item.path, "_blank")
          // e.stopPropagation()
          // console.log(item)
        } else {
          // console.log("zhi")
          // console.log(item.path)
          // 默认是替换了当前的窗口
          sessionStorage.setItem("childId", item.id)
          sessionStorage.setItem("keyword", "")
          setTimeout(() => {
            this.$router.push(
              item.path,
              () => {},
              () => {}
            )
          }, 200)
        }
      },
      handleInput() {
        if (this.seachKeyword) {
          sessionStorage.setItem("navIndex", -1)
          if (this.$route.path == "/search") {
            this.$router.push({
              query: {
                keyword: this.seachKeyword
              }
            })
          } else {
            let text = this.$router.resolve({
              path: "/search",
              query: {
                keyword: this.seachKeyword
              }
            })
            this.seachKeyword = ""
            // 打开一个新的页面
            window.open(text.href)
          }
        }
      },
      handleSearch() {
        if (this.$route.path == "/search") {
          return
        }
        this.$router.push({
          path: "/search"
        })
      },
      handlePro() {}
    }
  }
</script>
<style scoped lang="scss">
  /* 顶部 */
  #header {
    background: #f4f4f4;
    transition: all ease 0.6s;
  }
  #header a:focus,
  #header a:hover {
    text-decoration: none;
  }
  #header .header-top {
    height: 40px;
    color: #fff;
    font-size: 12px;
    line-height: 40px;
    /* background: #474747; */
    background: #003e8d;
  }
  #header .header-top-bg {
    background: url(../assets/img/map.png) no-repeat;
    background-position: 100% 40%;
    background-size: cover;
  }
  #header .container .en {
    font-family: Arial, sans-serif;
    text-align: center;
    font-size: 20px;
    opacity: 0.2;
    font-weight: 600;
    letter-spacing: 1px;
  }
  /* 顶部的图标 */
  #header .header-top span {
    margin: 0 8px;
  }
  #header .header-nav.container {
    padding-left: 0;
    padding-right: 0;
    display: flex;
  }
  /* 导航栏 */
  #header .header-nav {
    height: 60px;
    /* background: ; */
    clear: both;
  }
  /* 导航栏logo */
  #header .header-nav .header-nav-logo {
    color: #003e8d;
    height: 3em;
    width: auto;
  }
  /* 导航栏logo图片 */
  .header-nav-logo img {
    max-width: 420px;
    min-width: 360px;
    height: auto;
    margin: 0 auto;
  }
  .header-nav-background {
    background: #f3f6fb;
  }
  .header-nav-container {
    background: #003e8d;
  }
  .header-nav-logo {
    padding: 70px 0;
    background-image: url(../assets/img/logo_bg.png);
    background-repeat: no-repeat;
    background-position: center 80%;
    background-size: 100% 140%;
  }

  /* 导航栏 导航容器 */
  #header .header-nav .header-nav-wrapper {
    line-height: 60px;
    margin-bottom: 0;
    flex: 1;
    display: flex;
    justify-content: space-between;
    /* max-width: 970px; */
  }
  /* 导航栏 每个导航 */
  #header .header-nav .header-nav-wrapper > li {
    /* float: left; */
    display: inline-block;
    /* margin: 0 14px; */
    position: relative;
    // padding: 0 10px;
    // min-width: 70px;
    transition: all ease 0.5s;
    flex: 1;
    max-width: 150px;
  }
  #header .header-nav .header-nav-wrapper > li:hover {
    /* float: left; */
    display: inline-block;
    /* margin: 0 14px; */
    position: relative;
    background: rgba($color: #000, $alpha: 0.18);
    // padding: 0 10px;
  }
  /* 导航栏 每个导航下面的 a 链接 */
  #header .header-nav .header-nav-wrapper > li > a {
    color: #fff;
    font-size: 16px;
    // font-weight: 600;
    // padding: 6px 0;
    position: relative;
    display: inline-block;
    width: 100%;
    height: 50px;
    box-sizing: border-box;
    text-align: center;
  }
  /* 导航栏 每个导航a下面的 箭头 */
  #header .header-nav .header-nav-wrapper > li > a > .glyphicon {
    /* color: #000; */
    font-size: 10px;
    font-weight: normal;
  }
  /* 导航栏 每个导航下面的 a 链接的下划线 */
  // #header .header-nav .header-nav-wrapper > li > a > i {
  //   display: block;
  //   position: absolute;
  //   bottom: -2px;
  //   left: 50%;
  //   width: 0;
  //   height: 2px;
  //   opacity: 0;
  //   transition: all 0.6s ease;
  //   background-color: #fff;
  // }
  /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
  #header .header-nav .header-nav-wrapper > li > a > span {
    font-size: 12px;
    transition: transform ease 0.5s;
  }
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover {
    /* color: #003E8D; */
    text-decoration: none;
  }
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去下划线的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover .underline {
    opacity: 1;
    width: 100%;
    left: 0;
  }
  /* 导航栏 每个导航下面的 a 链接 鼠标滑上去三角标的样式 */
  #header .header-nav .header-nav-wrapper > li > a:hover span {
    transform: rotate(180deg);
  }
  /* 导航栏 每个导航下面的 a 链接 鼠标点击后的样式 */
  #header .header-nav .header-nav-wrapper > li.active {
    background: rgba($color: #000, $alpha: 0.18);
  }
  #header .header-nav .header-nav-wrapper > li.active > a {
    color: #fff;
    text-decoration: none;
    // border-bottom: 2px solid #fff;
    box-sizing: content-box;
  }
  /* 导航栏 每个导航下面的二级导航容器 */
  #header .header-nav .header-nav-wrapper > li > dl {
    display: none;
    position: absolute;
    min-width: 150px;
    max-width: 168px;
    top: 100%;
    left: 0;
    z-index: 9999999;
    box-shadow: 0 0 15px 4px rgba($color: #878a93, $alpha: 0.25);
    background: rgba(255, 255, 255, 0.95);
  }
  #header ul,
  #header li {
    cursor: pointer;
  }
  /* 导航栏 每个导航下面的二级导航容器的每个导航 */
  #header .header-nav .header-nav-wrapper > li > dl > dt {
    width: 100%;
    // padding: 14px 0;
    text-align: center;
  }
  #header .header-nav .header-nav-wrapper > li > dl > dt + dt {
    // border-top: 1px solid #363636;
  }
  #header .header-nav .header-nav-wrapper > li > dl > dt > a {
    // color: rgba(255, 255, 255, 0.9);
    font-weight: normal;
    font-size: 14px;
    display: block;
    color: #2d2f36;
    padding: 14px 0;
  }
  /* 导航栏 每个导航下面的二级导航容器的每个导航 当鼠标滑上时的样式*/
  #header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
    text-decoration: none;
    color: unset;
  }
  /* 导航栏 滑上一级导航显示二级导航 */
  #header .header-nav .header-nav-wrapper > li:hover dl {
    display: block;
    transition: transform ease 0.5s;
  }
  #header .header-nav .header-nav-wrapper > li > dl > dt:hover {
    cursor: pointer;
    background: rgba($color: #003e8d, $alpha: 0.1);
    // background: rgba(255, 255, 255, 0.2);
    transition: background ease 0.5s;
  }
  #header .header-nav .header-nav-wrapper > li > dl > dt > a:hover {
    color: unset;
  }
  #header .header-top .container {
    position: relative;
  }
  #header .header-top .header-search {
    position: absolute;
    right: 0;
    z-index: 99;
    top: 0;
    float: unset;
    height: auto;
    line-height: 36px;
  }
  #header .header-top .header-search .iconfont {
    font-size: 20px;
    right: 8px;
    height: 18px;
    line-height: 18px;
    top: 11px;
    color: #fff;
  }
  #header .header-search {
    float: right;
    font-size: 18px;
    list-style: none;
    height: 60px;
    line-height: 56px;
    overflow: hidden;
    width: 240px;
    position: relative;
    text-align: right;
  }
  #header .header-search .search-input {
    height: 30px;
    line-height: 30px;
    // color: #fff;
    // border-radius: 18px;
    border: none;
    transition: all ease 0.5s;
    width: 70px;
    // box-sizing: border-box;
    padding: 0 20px 0 8px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    border-bottom: 2px solid rgba($color: #fff, $alpha: 0.2);
    background: none;
    box-sizing: border-box;
  }
  #header .header-search .search-input::placeholder {
    color: rgba($color: #fff, $alpha: 0.4);
  }
  #header .header-search input.search-input:focus {
    width: 90%;
    // border: 1px solid #fff;
    outline: none;
    border-bottom: 2px solid rgba($color: #fff, $alpha: 0.8);
  }
  #header .header-search .iconfont {
    font-size: 20px;
    position: absolute;
    right: 8px;
    height: 18px;
    line-height: 18px;
    top: 21px;
    color: #fff;
  }
  @media screen and (max-width: 1199px) {
    #header .header-search {
      width: 160px;
    }
  }
  @media screen and (max-width: 998px) {
    #header {
      position: relative;
    }
    #header .header-search {
      position: absolute;
      top: -54px;
      right: 0;
      width: 80px;
    }
    #header .header-search .iconfont {
      font-size: 30px;
      color: #003e8d;
    }
    #header .header-nav-m {
      position: absolute;
      top: 78px;
      right: 0;
      width: 80px;
    }
    /* 导航栏logo容器 */
    #header .header-nav-m .header-nav-m-logo {
      height: 80px;
      position: relative;
    }
    /* 导航栏logo图片 */
    #header .header-nav-m .header-nav-m-logo img {
      width: 95px;
      height: 45px;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
    /* 导航栏  菜单容器 */
    #header .header-nav-m .header-nav-m-menu {
      color: #fff;
      height: 50px;
      font-size: 20px;
      line-height: 50px;
      background: rgba(255, 255, 255, 0.2);
      text-align: right;
      position: relative;
      padding-right: 10px;
    }
    /* 导航栏 菜单图标 */
    #header .header-nav-m .header-nav-m-menu-wrapper {
      width: 50px;
      height: 40px;
      color: #fff;
      z-index: 999999;
      font-size: 12px;
    }
    #header .header-nav-m .header-nav-m-menu-wrapper .iconfont {
      font-size: 30px;
      color: #003e8d;
    }
    /* 导航栏 */
    #header .header-nav-m .header-nav-m-wrapper {
      position: absolute;
      top: 50px;
      left: 0;
      width: 100%;
      background: rgba(0, 0, 0, 0.7);
      z-index: 9999999;
    }
    /* 导航栏 每个导航 */
    #header .header-nav-m .header-nav-m-wrapper > li {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #666;
      padding-right: 10px;
    }
    /* 导航栏 每个导航下面的 a 链接 */
    #header .header-nav-m .header-nav-m-wrapper > li > a {
      color: rgba(255, 255, 255, 0.8);
      font-size: 14px;
      /* padding: 15px 0; */
      position: relative;
    }
    /* 导航栏 每个导航下面的 a 链接的右侧小三角 */
    #header .header-nav .header-nav-wrapper > li > a > span {
      font-size: 10px;
    }
    .header-nav-logo {
      padding: 30px 0;
      background-position: 80% 90%;
      background-size: 140% 120%;
      box-shadow: 0 5px 20px rgba($color: #003e8d, $alpha: 0.15);
    }
    .header-nav-logo img {
      max-width: 280px;
      min-width: 240px;
      height: auto;
      margin: 0 0 auto 10px;
    }
    #header .header-top {
      height: 30px;
      line-height: 30px;
    }
    #header .container .en {
      font-family: Arial, sans-serif;
      text-align: center;
      font-size: 16px;
      opacity: 0.2;
      font-weight: 600;
      letter-spacing: 1px;
    }
    .header-nav-background-img {
      background-size: contain;
    }
  }
  #header .glyphicon {
    line-height: 40px;
    position: inherit;
    top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue